// src/utils/generateBarcode.js
//
// Генерация ВНУТРЕННЕГО штрихкода для товаров без заводского кода
// (овощи, развес, свои изделия).
//
// Формат: валидный EAN-13, начинающийся с «20».
// Префиксы 20–29 по стандарту GS1 зарезервированы под ВНУТРЕННЕЕ
// использование магазина и НИКОГДА не выдаются на реальные товары в мире —
// поэтому такой код гарантированно не столкнётся с заводским EAN.
// По префиксу «20» мы потом отличаем «свои» коды от заводских
// (для бумажного каталога), без отдельного поля в базе.

const PREFIX = '20';

// Код «ноунэйм» (товар без названия) для бумажного каталога: касса по нему
// сразу просит цену. 20 + 00000 + 00000: в весовом формате это PLU 0 и вес 0,
// а PLU у товаров — от 1, так что с весами он не пересекается.
export const NONAME_BARCODE = '2000000000008';

function ean13CheckDigit(twelve) {
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const d = twelve.charCodeAt(i) - 48;
    sum += (i % 2 === 0) ? d : d * 3;
  }
  return (10 - (sum % 10)) % 10;
}

function buildRandom() {
  for (;;) {
    let body = PREFIX;
    for (let i = 0; i < 10; i++) body += Math.floor(Math.random() * 10);
    const code = body + String(ean13CheckDigit(body));
    if (code !== NONAME_BARCODE) return code;
  }
}


// Наш ли это код: 13 цифр, префикс 20, валидная контрольная
export function isGeneratedBarcode(code) {
  const c = String(code || '').trim();
  if (!/^\d{13}$/.test(c)) return false;
  if (!c.startsWith(PREFIX)) return false;
  return ean13CheckDigit(c.slice(0, 12)) === (c.charCodeAt(12) - 48);
}

// isTaken(code) → Promise<bool>: занят ли код уже в каталоге
export async function generateUniqueBarcode(isTaken) {
  for (let attempt = 0; attempt < 8; attempt++) {
    const code = buildRandom();
    try {
      const taken = isTaken ? await isTaken(code) : false;
      if (!taken) return code;
    } catch (e) {
      return code;
    }
  }
  return buildRandom();
}

// Синхронная генерация: проверяем уникальность по уже загруженному списку
// кодов (без сети — клик срабатывает мгновенно). taken — Set строк-кодов.
export function generateBarcodeSync(takenSet) {
  const taken = takenSet instanceof Set ? takenSet : new Set(takenSet || []);
  for (let i = 0; i < 12; i++) {
    const code = buildRandom();
    if (!taken.has(code)) return code;
  }
  return buildRandom();
}
